import { createRoute } from '@tanstack/react-router'
import AnalyticsPage from '@/features/analytics/pages/AnalyticsPage'
import { Route as authenticatedRoute } from './route'

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/analytics',
  component: AnalyticsPage,
})
